/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Passkey_Error_CancelledInputs */



/**
* | output |
* | --- |
* | "Passkey creation was cancelled." |
*
* @param {Passkey_Error_CancelledInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const passkey_error_cancelled = /** @type {((inputs?: Passkey_Error_CancelledInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Passkey_Error_CancelledInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("La création de la Passkey a été annulée.")
	if (locale === "es") return /** @type {LocalizedString} */ ("La creación del Passkey fue cancelada.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("A criação da Passkey foi cancelada.")
	if (locale === "it") return /** @type {LocalizedString} */ ("La creazione della Passkey è stata annullata.")
	return /** @type {LocalizedString} */ ("Passkey creation was cancelled.")
});